import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import { EventEmitter } from 'fbemitter';

export var Ticker = function () {
  function Ticker() {
    var _this = this;

    _classCallCheck(this, Ticker);

    this.tick = function () {
      _this.frame = requestAnimationFrame(_this.tick);
      _this.emitter.emit('onTick', _this.frame);
    };

    this.frame = 0;
    this.emitter = new EventEmitter();
  }

  Ticker.prototype.startTicking = function startTicking() {
    this.tick();
  };

  Ticker.prototype.stopTicking = function stopTicking() {
    cancelAnimationFrame(this.frame);
  };

  Ticker.prototype.onTick = function onTick(handle) {
    return this.emitter.addListener('onTick', handle);
  };

  return Ticker;
}();